import React from "react";
import PropTypes from "prop-types";
import InputAdornment from "@mui/material/InputAdornment";

import DialogFormWithMutation from "dialogs/DialogFormWithMutation";
import { FormGroupTitle, FormSwitchField, FormTextField } from "ui/Form";

import useFormValidator from "hooks/useFormValidator";

import {
  READ_SERVER_SETTINGS_QUERY,
  UPDATE_OKTA_SETTINGS,
} from "graphqlQueries/system";

import {
  OKTA_ACCOUNT_DOMAIN_TITLE,
  OKTA_APPLICATION_ID_TITLE,
  OKTA_APPLICATION_SECRET_TITLE,
  OKTA_AUTHENTICATION_AUDIENCE_TITLE,
  OKTA_AUTHENTICATION_ID_TITLE,
  OKTA_AUTHENTICATION_TITLE,
  OKTA_REDIRECT_URL_TITLE,
} from "constants/repoSettings";

const fieldsWithPlaceForError = [
  "app_id",
  "app_secret",
  "auth_server_audience",
  "auth_server_id",
  "org_domain",
  "redirect_uri",
];

const UpdateOktaSettingsDialog = (props) => {
  const { oktaInfo } = props;

  const initialValues = {
    app_id: oktaInfo.app_id,
    app_secret: "",
    auth_server_audience: oktaInfo.auth_server_audience,
    auth_server_id: oktaInfo.auth_server_id,
    org_domain: oktaInfo.org_domain,
    enabled: oktaInfo.enabled,
    redirect_uri: oktaInfo.redirect_uri?.replace(/\/okta_auth$/, "") || "",
  };

  const { validationSchema } = useFormValidator(
    "update_okta_settings",
    {
      app_id: OKTA_APPLICATION_ID_TITLE,
      auth_server_audience: OKTA_AUTHENTICATION_AUDIENCE_TITLE,
      auth_server_id: OKTA_AUTHENTICATION_ID_TITLE,
      org_domain: OKTA_ACCOUNT_DOMAIN_TITLE,
      app_secret: OKTA_APPLICATION_SECRET_TITLE,
      redirect_uri: OKTA_REDIRECT_URL_TITLE,
    },
    {},
    { redirect_uri: "/okta_auth" },
  );

  const dataMapper = (data) => {
    const data_ = JSON.parse(JSON.stringify(data));
    data_.app_secret === "" && delete data_.app_secret;
    data_.redirect_uri = data_.redirect_uri + "/okta_auth";
    return data_;
  };

  return (
    <DialogFormWithMutation
      mutationQueries={UPDATE_OKTA_SETTINGS}
      refetchQueries={[READ_SERVER_SETTINGS_QUERY]}
      initialValues={initialValues}
      dataMapper={dataMapper}
      validationSchema={validationSchema}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="Edit Okta"
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <FormGroupTitle title="Okta information" />
      <FormTextField name="app_id" label={OKTA_APPLICATION_ID_TITLE} />
      <FormTextField
        name="auth_server_audience"
        label={OKTA_AUTHENTICATION_AUDIENCE_TITLE}
      />
      <FormTextField
        name="auth_server_id"
        label={OKTA_AUTHENTICATION_ID_TITLE}
      />
      <FormTextField name="org_domain" label={OKTA_ACCOUNT_DOMAIN_TITLE} />
      <FormTextField
        name="app_secret"
        label={OKTA_APPLICATION_SECRET_TITLE}
        type="password"
      />
      <FormTextField
        name="redirect_uri"
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">/okta_auth</InputAdornment>
            ),
          },
        }}
      />
      <FormSwitchField name="enabled" label={OKTA_AUTHENTICATION_TITLE} />
    </DialogFormWithMutation>
  );
};

UpdateOktaSettingsDialog.propTypes = {
  oktaInfo: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UpdateOktaSettingsDialog;
